import React from "react";
import { useBrand } from "@edreamsodigeo/frontend-core";
import { BackgroundImage, Box, Flex } from "@edreamsodigeo/prisma-design-system";
import { getBrandedImage } from "../../utils/images";
import ValuePropositionFooter from "./components/ValuePropositionFooter";
import ValuePropositionHeader from "./components/ValuePropositionHeader";
import ValuePropositionList from "./components/ValuePropositionList";
const SupportAreaValuePropositionDesktop = () => {
  const brand = useBrand();
  const backgroundImage = `url("${getBrandedImage("BSA_images_SA.png", brand, "/images/SEP/SA/")}")`;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "primary.20",
    width: "100%",
    height: "100%",
    maxWidth: "372px"
  }, /*#__PURE__*/React.createElement(BackgroundImage, {
    backgroundImage: backgroundImage,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "calc(100% + 30px) calc(100% + 30px)",
    backgroundSize: "200px"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    p: "2x_big",
    height: "100%"
  }, /*#__PURE__*/React.createElement(ValuePropositionHeader, null), /*#__PURE__*/React.createElement(Box, {
    maxWidth: "85%",
    mt: "2x_big"
  }, /*#__PURE__*/React.createElement(ValuePropositionList, null)), /*#__PURE__*/React.createElement(Box, {
    maxWidth: "55%",
    mt: "auto",
    pt: "2x_big"
  }, /*#__PURE__*/React.createElement(ValuePropositionFooter, null)))));
};
export default SupportAreaValuePropositionDesktop;